import { useMemo, useRef, useState } from "react";
import axiosInstance from "utils/axios";

// components
import { PopUpModal, PortFolioRow } from "utils/unitComponent.js";

// ----------------------------------------------------------------------

export default function PortFolio() {
  const [show, setShow] = useState(false);

  const len = 20;
  const speed = 10;
  const ref = useRef([]);

  return (
    <>
      <PortFolioRow
        ref={(el) => (ref.current.first = el)}
        {...{ len, speed }}
        items={[1, 2, 3, 4, 5]}
        show={show}
        setShow={setShow}
      />

      <PortFolioRow
        ref={(el) => (ref.current.second = el)}
        {...{ len, speed }}
        items={[1, 2, 3, 4, 5]}
        direction="right"
        show={show}
        setShow={setShow}
      />

      <PortFolioRow
        ref={(el) => (ref.current.third = el)}
        {...{ len, speed }}
        items={[1, 2, 3, 4, 5]}
        show={show}
        setShow={setShow}
      />
      {/* ------------------------------------------------------------- */}

      {/* popup-modal */}
      <PopUpModal show={show} close={() => setShow(false)} />
    </>
  );
}
